<template>
    <div class="content">
        <div class="img-box">
           
             <img v-show="round.round_id === 5" src="../../assets/images/personal/step2chahua.png" alt="">
             <img v-show="round.round_id === 1" class="qrcode" :src="imgHsot + url" alt="">
        </div>
        <p v-show="round.round_id === 1" >扫描上方二维码加入钉钉群</p>
        <!-- <p v-show="round.round_id === 1">4月8日前报名参赛，并扫码入群
            4月10日上午10时至晚上8时（第一轮）
            4月12日上午10时至晚上8时（第二轮）</p> -->
        <!-- <p v-show="round.round_id === 1">请于<span>{{date}}</span>到<span>实习僧</span>网站答题</p>
        <el-button v-show="round.round_id === 1" class="dogo" @click="toOutLink">去答题</el-button> -->
        <p v-show="round.round_id === 5">请于<span>{{date}}</span>上传图片</p>
        <el-button v-show="round.round_id === 5" class="dogo" @click="toOutLink">上传图片</el-button>
    </div>
</template>

<script>
import moment from 'moment'
import {apiGetOssConfig} from '../../plugins/apis'
export default { 
  data () {
    return {
        url:'',
        imgHsot:process.env.VUE_APP_API_URL,
        // toOutLink2:'',
    }   
  }, 
  computed:{
      date(){
          if(this.process){ 
            let date = moment(this.process.start_t).format("MM月DD日 ahh时")+"~"+moment(this.process.end_t).format("MM月DD日 ahh时")
            return date.replace('am','上午').replace('am','上午').replace('pm','下午').replace('pm','下午')
          }else{
              return ''
          }
      }
  },
  methods: {
      async getConfig(){
          let res = await apiGetOssConfig()
          if(res.code === 200){
              this.url = res.data.system_dingding
          }
      },
    toOutLink(){
        if(this.round){
            window.open(this.round.out_link)
        } 
    }
  },
  async mounted () {
    await this.getConfig()
  },
  props:['process','round']
}
</script> 

<style scoped>
    .content{
        /* height: 500px; */
        padding-bottom: 30px;
        text-align: center;
    }
    
    img{
        margin: 10px 10px 30px;
        width: 252px;
        height: 252px;
    }
    .qrcode{
        width: 200px;
        height: 200px;
    }
    p{
        line-height: 30px;
        font-size: 18px;
        color: #414141;
    }
    p span{
        color: #733085;
    }
    .dogo{
        margin-top: 30px;
        border:#733085;
        background: #733085;
        color: #FFFFFF;
   }
   .dogo:focus, .dogo:hover {
    color: #fff;
    border-color: #733085;
    background-color: #733085;
    }
</style>
